// extracted by mini-css-extract-plugin
export default {"root":"_1eGI5","subtitle":"ycs5L"};